import * as React from "react";
import { SVGProps } from "react";

const CompoundUsdCoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    {...props}
  >
    <circle cx={128.1} cy={128.2} r={127.9} fill="#edf0f2" />
    <linearGradient
      id="a"
      x1={92.094}
      x2={132.188}
      y1={243.655}
      y2={21.361}
      gradientTransform="matrix(1 0 0 -1 0 258)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#27d3a2" />
      <stop offset={1} stopColor="#9388fd" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M209.3 226.9c-19.5 16.1-43.4 26-68.6 28.4-33.7 3.3-67.4-6.9-93.7-28.4C20.8 205.4 4.2 174.4.8 140.6c-2.5-25.2 2.5-50.5 14.4-72.8 11.9-22.3 30.2-40.6 52.5-52.5C90 3.4 115.3-1.7 140.5.8c25.2 2.5 49 12.3 68.6 28.4l-25.8 31.5C170 49.8 153.7 43 136.5 41.4c-17.2-1.7-34.4 1.8-49.6 9.9-15.2 8.1-27.6 20.6-35.8 35.8-8.1 15.2-11.5 32.5-9.8 49.6 2.3 23 13.6 44.2 31.5 58.8 17.9 14.7 40.9 21.6 63.9 19.3 17.2-1.7 33.4-8.5 46.7-19.4l25.9 31.5z"
    />
    <path
      fill="#fff"
      d="M128.5 232.9c57.7 0 104.4-46.8 104.4-104.4C232.9 70.8 186.2 24 128.5 24S24 70.8 24 128.5s46.8 104.4 104.5 104.4z"
    />
    <path
      fill="#283947"
      d="M145.9 136.8c0-9.8-6-13.1-17.7-14.6-8.6-1.2-10.3-3.2-10.3-7.2s2.9-6.4 8.5-6.4c5.1 0 8 1.7 9.2 5.8.1.4.4.8.8 1.1.4.3.8.4 1.3.4h4.5c.3 0 .6-.1.8-.2.3-.1.5-.3.7-.5.2-.2.3-.5.4-.7.1-.3.1-.6 0-.9-1.4-6.4-5.8-10.2-12.6-11.4v-6.7c0-.6-.2-1.1-.6-1.5-.4-.4-.9-.6-1.5-.6h-4.3c-.6 0-1.1.2-1.5.6-.4.4-.6.9-.6 1.5v6.5c-8.5 1.2-13.9 6.7-13.9 13.8 0 9.2 5.7 12.7 17.5 14.3 8.1 1.3 10.4 3 10.4 7.5s-3.9 7.5-9.4 7.5c-7.4 0-9.9-3.2-10.8-7.3-.1-.5-.4-.9-.7-1.2-.4-.3-.9-.5-1.3-.5h-4.9c-.3 0-.6.1-.8.2-.3.1-.5.3-.7.5-.2.2-.3.5-.4.7-.1.3-.1.6 0 .8 1.2 7 5.8 12.1 15.1 13.3v6.6c0 .6.2 1.1.6 1.5.4.4.9.6 1.5.6h4.3c.6 0 1.1-.2 1.5-.6.4-.4.6-.9.6-1.5v-6.6c8.7-1.4 14.3-7.3 14.3-14.8z"
    />
    <path
      fill="#657786"
      d="M113.6 166.8c-8.1-2.9-15.1-8.3-20.1-15.3-5-7-7.6-15.4-7.6-23.9s2.7-16.9 7.6-23.9c5-7 12-12.4 20.1-15.3.5-.2 1-.6 1.3-1.1.3-.5.5-1 .5-1.6v-3.9c0-.3 0-.7-.2-1-.1-.3-.4-.6-.7-.8-.3-.2-.6-.3-1-.4s-.7 0-1 .2C102.3 83 93.4 89.4 87 98c-6.3 8.6-9.7 18.9-9.7 29.6 0 10.6 3.4 21 9.7 29.6 6.3 8.6 15.2 14.9 25.5 18.2.3.1.7.2 1 .2.3 0 .7-.2 1-.4.3-.2.5-.5.7-.8.1-.3.2-.7.2-1v-3.9c0-.6-.2-1.1-.5-1.6s-.7-.9-1.3-1.1zm29-86.9c-.3-.1-.7-.2-1-.2-.3 0-.7.2-1 .4-.3.2-.5.5-.7.8-.1.3-.2.7-.2 1v3.9c0 .6.2 1.1.5 1.6s.8.8 1.3 1.1c8.1 2.9 15.1 8.3 20.1 15.3 5 7 7.6 15.4 7.6 23.9s-2.7 16.9-7.6 23.9c-5 7-12 12.4-20.1 15.3-.5.2-1 .6-1.3 1-.3.5-.5 1-.5 1.6v3.9c0 .3 0 .7.2 1 .1.3.4.6.7.8.3.2.6.3 1 .4.3 0 .7 0 1-.2 10.2-3.2 19.1-9.6 25.5-18.2 6.3-8.6 9.7-18.9 9.7-29.6 0-10.6-3.4-21-9.7-29.6-6.4-8.5-15.3-14.9-25.5-18.1z"
    />
  </svg>
);

export default CompoundUsdCoin;
